export class LocalStorage {
  private static ALLOW_KEY = '__lair_cookie_allow__'

  public static allowCookie() {
    this.setBool(this.ALLOW_KEY, true, true)
  }

  public static declineCookie() {
    this.remove(this.ALLOW_KEY)
  }

  public static isAllowed() {
    return this.getBool(this.ALLOW_KEY)
  }

  public static get(key: string) {
    return localStorage.getItem(key)
  }

  public static getBool(key: string) {
    return localStorage.getItem(key) === 'true'
  }

  public static getJson<T>(key: string): T | null {
    const value = this.get(key)
    return value ? JSON.parse(value) : null
  }

  public static set(key: string, value: string, force = false) {
    if (!force && !this.isAllowed()) return
    localStorage.setItem(key, value)
  }

  public static setBool(key: string, value: boolean, force = false) {
    this.set(key, value.toString(), force)
  }

  public static setJson(key: string, value: any, force = false) {
    this.set(key, JSON.stringify(value), force)
  }

  public static has(key: string) {
    return this.get(key) !== null
  }

  public static remove(key: string) {
    localStorage.removeItem(key)
  }
}
